import SearchFilterBar from '../../components/ui/search-filter-bar';
import Pagination from '../../components/ui/pagination';
import ProposalTHead from '../../components/ui/proposal-thead';
import ProposalListTBody from '../../components/module/proposal-status/proposal-list-tbody';
import ProposalActionModal from '../../components/module/proposal-status/modal/preview-proposal/proposal-action-modal';
import { useProposalTable } from '../../hooks/proposal/use-proposal-table';
import ProposalComputation from '../../components/module/proposal-computation/modal/computation/proposal-computation-modal';
import ProposalDetails from '../../components/module/proposal-status/modal/proposal-details';
import { useProposalsSocket } from '../../hooks/socket/use-proposals-socket';
import SectionHeader from '../../components/ui/section-header';
import { proposalHeaderData } from '../../constant/gms-constant';
import ComputationDetails from '../../components/module/proposal-computation/modal/others/computation-details';
import { useFilesActions } from '../../hooks/actions/use-files-actions';
import { useModalAccess } from '../../components/global/modal/use-modal-access';

export default function ComputationProposalPage() {
    
    const {
        isUpdateProposal,
        isShowComputationDetails,
        isShowProposalDetails,
        isShowActionProposalModal,
    } = useModalAccess()
    const { handleViewProposal } = useFilesActions()
    const {
        normalizedOptions,
        errorMessage,
        searchType,
        setSearchType,
        searchValue,
        setSearchValue,
        setPage,
        pagedData,
        loading,
        isErrorGetProposal,
        handleReload,
        getProposal,

        defaultTotalPages,
        proposalDefaultPageSize,
        handleChangePageSize
    } = useProposalTable();
    
    useProposalsSocket()

    const tHeads: string[] = [
        proposalHeaderData.proposalStatus.label,
        proposalHeaderData.ratesStatus.label,
        proposalHeaderData.computedBy.label,
        proposalHeaderData.proposalAs.label,
        proposalHeaderData.groupName.label,
        proposalHeaderData.proposalType.label,
        proposalHeaderData.product.label,
        proposalHeaderData.preparedBy.label,
    ]
    
    return (
        <div className="flex h-full min-h-0 w-full flex-col bg-[#f8fafc] rounded-xl border border-gray-200">
            <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
                <SectionHeader 
                    title='Proposal Computation'
                    subtitle='View and compute the rates for different age profiles in submitted proposals.'
                    icon={
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
                            <rect x="5" y="2.5" width="14" height="19" rx="2" />
                            <path strokeLinecap="round" d="M8 6h8M8 10h2M14 10h2M8 14h2M14 14h2M8 18h8" />
                        </svg>
                    }
                />
                {/* <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
                    <div className="p-3 sm:p-4">
                        <SearchFilterBar
                            searchType={searchType}
                            setSearchType={setSearchType}
                            searchValue={searchValue}
                            setSearchValue={setSearchValue}
                            options={normalizedOptions}
                        />
                    </div>
                </div> */}
                <div className="mx-auto flex min-h-0 w-full flex-1 flex-col gap-2">
                    <div className="flex min-h-0 flex-1 flex-col overflow-hidden bg-white shadow-sm">
                        <div className="shrink-0 border-b border-gray-200 p-3">
                            <SearchFilterBar
                                searchType={searchType}
                                setSearchType={setSearchType}
                                searchValue={searchValue}
                                setSearchValue={setSearchValue}
                                options={normalizedOptions}
                            />
                        </div>
                        {getProposal?.pagination && (
                            <div className="shrink-0 border-b border-gray-200 bg-gray-50/60 p-3">
                                <Pagination
                                    setPage={setPage}
                                    handleReload={handleReload}
                                    pagination={getProposal.pagination}
                                    defaultTotalPages={defaultTotalPages}
                                    setDefaultTotalPages={handleChangePageSize}
                                    totalPagesOptions={proposalDefaultPageSize}
                                />
                            </div>
                        )}
                        <div className="min-h-0 flex-1 overflow-auto">
                            <table className="min-w-max w-full border-collapse">
                                <ProposalTHead headers={tHeads} />
                                <ProposalListTBody
                                    headers={tHeads}
                                    typeOfIcon="compute"
                                    isLoadingGetProposal={loading}
                                    isErrorGetProposal={isErrorGetProposal}
                                    errorMessage={errorMessage}
                                    getProposal={pagedData}
                                    handleEdit={handleViewProposal}
                                />
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {isShowActionProposalModal && ( <ProposalActionModal typeOfIcon='compute'/> )}
            {isUpdateProposal && ( <ProposalComputation /> )}
            {isShowComputationDetails && <ComputationDetails/>}
            {isShowProposalDetails && ( <ProposalDetails /> )}
        </div>
    )
}